import gql from 'graphql-tag';

export const MARK_DONE = gql`
mutation MarkDone($id: Int!) {
    update_todo(
        where: {id: {_eq: $id}},
        _set: {
          done: true,
          
        }
      ) {
        affected_rows
        returning {
          id
          
        }
      }
  }
`;

export const TODO = gql` 
  query { 
  todo(order_by: {id: desc}){
    id
    todo
    done
  }
}
`;
export const ADD_TODO = gql`
mutation AddTodo($todo: String!) {
  insert_todo(objects:[{todo:$todo}]){
    returning{
      id
    }
  }
}
`;



export const DEL_TODO = gql`
mutation DeleteTodo($id: Int!) {
    delete_todo(where:{id:{_eq:$id}}){
        affected_rows
      }
  }
`;

export const ADD_JOB = gql`
mutation addJob($title: String!, $description: String!, $status: String!, $budget: String!, $currency: String!, $user: String!, $time: String!, $contact: String!,$skills: String!) {
  insert_fl_jobs(objects:[{title:$title, 
                          description:$description,
                          status:$status,
                          budget:$budget
                          currency:$currency,
                          user:$user,
                          time:$time,
                          contact:$contact,
                          skills:$skills}]){
    returning{
      id
    }
  }
}
`;

export const LIST_JOB = gql` 
  query { 
  fl_jobs(order_by: {id: desc}){
    id
    title
    description
    currency
    budget
    status
    time
    user
    time
    contact
    skills
  }
}
`;

export const DEL_JOB = gql`
mutation DeleteJob($id: Int!) {
    delete_fl_jobs(where:{id:{_eq:$id}}){
        affected_rows
      }
  }
`;

export const POSTS_COUNT = gql` 
query {
  posts: fl_jobs_aggregate {
    posts_agg: aggregate {
      count(columns: id)
    }
  }
}

`;

export const DIST_USER = gql` 
  query { 
    users: fl_jobs_aggregate {
      users_agg: aggregate {
        count(distinct: true, columns: user)
      }
    }
}
`;

const SEARCH_POSTS = gql`
  query($searchQuery: String) {
    fl_jobs(filter: {
      skills: {
        contains: $searchQuery
      }
    }) {
      items {
        id
    title
    description
    currency
    budget
    status
    time
    user
    time
    contact
    skills
      }
    }
  }
` 
